import { reactive, computed } from '@vue/composition-api'

export const ContractFreeTrialRequestInput = (props, context) => {
  const store = context.root.$store
  const router = context.root.$router
  const { trial } = store.state
  store.dispatch('contractPack/getPackageData')
  const canTrialProduct = computed(() => store.getters['contractPack/canTrialProduct'])

  const trialState = reactive({
    products: [],
    chargeName: null
  })
  // TODO: 確認ボタン押したときの処理
  const action = reactive({
    confirm: () => {
      store.dispatch('common/showLoading')
      store
        .dispatch('trial/confirm', trialState)
        .finally(() => {
          store.dispatch('common/hideLoading')
        })
    },
    complete: () => {
      store.dispatch('common/showLoading')
      store
        .dispatch('trial/complete')
        .finally(() => {
          store.dispatch('common/hideLoading')
        })
    },
    close: () => {
      store.dispatch('common/showLoading')
      store
        .dispatch('trial/close')
        .finally(() => {
          store.dispatch('common/hideLoading')
        })
    },
    finish: () => {
      store.dispatch('common/showLoading')
      store
        .dispatch('trial/close')
        .then(() => {
          router.push({ name: 'PCService' })
        })
        .finally(() => {
          store.dispatch('common/hideLoading')
        })
    }
  })
  const state = reactive({
    visibleRequestConfirm: false,
    visibleRequestComplete: false
  })

  return {
    state,
    trialState,
    canTrialProduct,
    action,
    trial
  }
}
